import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { StyledEngineProvider, CssBaseline } from '@mui/material';

import './App.css';
import { ThemeProvider } from '/packages/shared-components/utils/ThemeContext';
import { Routes } from './Routes';
import { ModalProvider } from '/packages/shared-components/utils/modal';
import { FlashMessageProvider } from '/packages/shared-components/utils/flashMessage';
import { SubscriptionConnectionContextProvider } from '~/src/utils/subscription-ws/useWsSubscriptionContext';
import { UserProvider, useUser } from '~/src/utils/user';

import { SelectedDeviceProvider } from '~/src/utils/useSelectedDevice';
import { ProjectContextProvider } from '~/src/utils/projectProvider';
import { PartnerContextProvider } from '~/src/utils/partnerProvider';

import { client } from '~/src/utils/apollo';
import { ChatAssistantGate } from '/packages/shared-components/ChatAssistant/ChatAssistantGate';
import { LaunchDarklyUserIdentify } from '/packages/shared-components/utils/launchDarkly/LaunchDarklyUserIdentify';

function App() {
  return (
    <ApolloProvider client={client}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider defaultMode="light">
          <CssBaseline />
          <div className="App">
            <BrowserRouter>
              <FlashMessageProvider>
                <ModalProvider>
                  <UserProvider>
                    <PartnerContextProvider>
                      <ProjectContextProvider>
                        <SubscriptionConnectionContextProvider>
                          <SelectedDeviceProvider>
                            <Routes />
                            <LaunchDarklyUserIdentify app="portal" useUser={useUser} />
                            <ChatAssistantGate useUser={useUser} />
                          </SelectedDeviceProvider>
                        </SubscriptionConnectionContextProvider>
                      </ProjectContextProvider>
                    </PartnerContextProvider>
                  </UserProvider>
                </ModalProvider>
              </FlashMessageProvider>
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </StyledEngineProvider>
    </ApolloProvider>
  );
}

export default App;
